// extracted by mini-css-extract-plugin
export var text = "_8c-0";